export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11888.116f8f74.jpg";